/**
 * Default sort slug for main category listing URLs (`/{category}/all/{sort}/1`).
 * Must match a key in `translateSort` (maps to GraphQL `dateAdded` DESC).
 */
export const DEFAULT_CATEGORY_SORT_SLUG = 'newest' as const
